import styled from "styled-components";

export const BodyModalDadosBancarios = styled.div`
  padding: 16px 24px 24px 24px;
  max-height: 440px;
  overflow-y: auto;
`;

export const ContainerDadosConta = styled.div`
  padding: 24px;
  background-color: #f5f5f5;
  font-size: 14px;
  border-radius: 5px;
`;

export const TituloContainer = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
`;
